import type { CompoundLibEntry } from "@/utils/types/compound";

// FOUNDATION_FORMULATION used to live here as a 3-row formulation seed; it
// has been removed along with INITIAL_FORMULATION because the workbench now
// sources its rows from the server (useFlavorFormulas). What remains is the
// compound-metadata library below, which the runtime compound registry uses
// as a fallback when server-fetched substance names haven't loaded yet.
export const FOUNDATION_COMPOUNDS: CompoundLibEntry[] = [
  {
    id: "f01",
    name: "Propylene glycol",
    cas: "57-55-6",
    family: "neutral",
    kind: "carrier",
    desc: "FCC carrier · neutral, hygroscopic",
    threshold: 0,
    role: "carrier",
    position: null,
    chemClass: "alcohol",
    solvent: "water",
  },
  {
    id: "f02",
    name: "Triacetin",
    cas: "102-76-1",
    family: "neutral",
    kind: "carrier",
    desc: "GRAS plasticizer · mildly sweet, neutral lift",
    threshold: 0,
    role: "carrier",
    position: null,
    chemClass: "ester",
    solvent: "oil",
  },
  {
    id: "f03",
    name: "Ethanol (95%, food)",
    cas: "64-17-5",
    family: "neutral",
    kind: "carrier",
    desc: "Food-grade ethanol · top-note diffuser",
    threshold: 0,
    role: "carrier",
    position: null,
    chemClass: "alcohol",
    solvent: "water",
  },
];
